import { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { Routes } from '../../constants/RouteConstants';
import useMakeRequest from '../../utils/ApiHelper';
import { ApiConstants } from '../../constants/ApiConstants';
import Skeleton from '../../components/ui/Skeleton';
import { checkPermission, getMemberType, getPricingType, hasAnySubscription } from '../../utils/Helper';
import authContext from '../../context/authContext';
import { ApiTypes, HOUSEHOLD_TYPES, PERMISSIONS, USER_ROLE_TYPES } from '../../constants/Constants';
import toast from 'react-hot-toast';
import Button from '../../components/ui/Button';
import $ from 'jquery';
import CommanPhoneNumber from '../../components/ui/PhoneNumber';
import ValidationMessage from '../../constants/ValidationMessage';
import MembersList from './MembersList';
import TopHeader from '../../components/layouts/TopHeader';
import PageLayout from '../../components/ui/PageLayout';
import verticalDots from '../../assets/images/verticaldots-icon.svg'
import addIcon from '../../assets/images/add-icon.svg'
import editIcon from '../../assets/images/menu/edit-icon.svg'
import binIcon from '../../assets/images/menu/bin-icon.svg'
import CustomModal from '../../components/layouts/CustomModal';
import UpgradeToast from '../../components/layouts/UpgradeToast';


const ManageHousehold = () => {

    const navigate = useNavigate();
    const hhDetails = useMakeRequest()
    const hhMembers = useMakeRequest();
    const removeMember = useMakeRequest();
    const inviteMember = useMakeRequest();
    const deleteHouse = useMakeRequest();
    const sendCred = useMakeRequest();
    const [removeId, setRemoveId] = useState(null);
    const profile: any = useContext(authContext);
    const [visibleRemoveHH, setVisibleRemoveHH] = useState<boolean>(false);
    const [callEffect, setCallEffect] = useState<boolean>(true);
    const [emailError, setEmailError]: any = useState(null);
    const [loadingMemb, setLoadingMemb]: any = useState([]);
    const [inviteMemberForm, setInviteMemberForm]: any = useState(null);
    const [memberType, setMemberType] = useState<string | 'approved' | 'pending' | 'rejected'>('approved')


    useEffect(() => {
        if (profile?.data?.hh_member) {
            hhDetails.makeRequest({ url: ApiConstants?.GetHouseholdDetails });
        }
    }, [profile?.data?.hh_member]);


    useEffect(() => {
        if (profile?.data?.hh_member) {
            hhMembers.makeRequest({ payload: { type: memberType }, url: ApiConstants?.GetHouseholdMembers })
        }
    }, [profile?.data, memberType, callEffect])

    useEffect(() => {
        if (removeMember?.status) {
            $('#btn-close-modal').click();
            hhMembers.makeRequest({ url: ApiConstants?.GetHouseholdMembers })
        }
    }, [removeMember?.status])

    useEffect(() => {
        if (deleteHouse?.status) {
            $('#btn-close-household-modal').click();
            const fetch = async () => {
                await profile.makeRequest({ url: ApiConstants?.Profile, type: ApiTypes?.GET })
            }
            setTimeout(async () => {
                fetch()
            }, 1000);
        }
    }, [deleteHouse?.status])

    const handleRemoveMember = () => {
        toast.promise(
            removeMember.makeRequest({ payload: { remove_id: removeId }, url: ApiConstants?.RemoveHouseholdMember }),
            {
                loading: 'Processing...',
                success: (data: any) => data.message,
                error: (error: any) => error.message,
            }
        );
        setRemoveId(null)
    }

    const handleDeleteHouseHold = () => {
        setCallEffect(false);
        toast.promise(
            deleteHouse.makeRequest({ url: ApiConstants?.DeleteHouse, type: "POST" }),
            {
                loading: 'Processing...',
                success: (data: any) => data.message,
                error: (error: any) => error.message,
            }
        );
        setVisibleRemoveHH(false)

    }

    const handleSendSendCredential = (memberId: any) => {
        setLoadingMemb([...loadingMemb, memberId])
        toast.promise(
            sendCred.makeRequest({ payload: { member_id: memberId, is_pending_request: 1 }, url: ApiConstants?.HouseholdSendCredential }),
            {
                loading: 'Processing...',
                success: (data: any) => data.message,
                error: (error: any) => error.message,
            }
        );
    }

    const handlePhoneNumber = (value: any, code: any, phone: any) => {
        setInviteMemberForm({
            ...inviteMemberForm,
            phone_country_code: code?.dialCode,
            phone_number: phone
        })
    }

    const handleInvite = () => {
        if (inviteMemberForm?.email) {
            if (ValidationMessage.EMAIL_REGREX.test(inviteMemberForm?.email)) {
                const payload = {
                    ...inviteMemberForm,
                    isProxy: 1
                }
                setEmailError(null)
                toast.promise(
                    inviteMember.makeRequest({ payload: payload, url: ApiConstants?.HouseholdSendInvitation }),
                    {
                        loading: 'Processing...',
                        success: (data: any) => data.message,
                        error: (error: any) => error.message,
                    }
                );
            } else {
                setEmailError(ValidationMessage.EMAIL_ADDRESS)
            }
        } else {
            setEmailError(ValidationMessage.Field("your email"))
        }
    }

    useEffect(() => {
        if (sendCred?.status) {
            let memb = [...loadingMemb];
            memb = memb.filter((id) => id !== sendCred?.data?.data?.member_id)
            setLoadingMemb(memb)
        } else {
            setLoadingMemb([])
        }
    }, [sendCred?.status])

    useEffect(() => {
        if (inviteMember?.status) {
            $('.btn-close-modal').click()
            hhMembers.makeRequest({ url: ApiConstants?.GetHouseholdMembers })
        }
    }, [inviteMember?.status])

    useEffect(() => {
        return () => {
            $('.modal-backdrop').remove();
        }
    }, [])

    const HouseHoldName = hhDetails?.data?.data?.name ?? "Household"
    const locality = hhDetails?.data?.data?.locality_detail?.label ?? "N/A"
    const pricingType = getPricingType(hhDetails?.data?.data?.task_pricing_type) ?? "N/A"

    return (
        <PageLayout headerName='Households' onlyTitle={false}>
            <div className="manage-household-page">
                <div className="manage-household-outer">
                    {/* Household Green Card */}
                    {/* {profile?.data?.hh_member ? ( */}
                    <>
                        <div className='household-main-card'>
                            <div className='household-header'>
                                <h2 className='household-title'>{HouseHoldName}</h2>

                                {(profile?.data?.hh_member && profile?.data?.role_type === USER_ROLE_TYPES?.GROUP_ADMIN) || !profile?.data?.hh_member ? (
                                    <div className="menu-btn">
                                        <img src={verticalDots} alt="menu" />
                                        <div className="remove-card-txt">
                                            {profile?.data?.hh_member &&
                                                profile?.data?.role_type === USER_ROLE_TYPES?.GROUP_ADMIN ? (
                                                <>
                                                    <Link to={Routes?.EditHousehold} className="remove-card-inner">
                                                        <img src={editIcon} alt="edit" className="menu-icon" />
                                                        <span>Edit</span>
                                                    </Link>

                                                    <div
                                                        onClick={() => setVisibleRemoveHH(true)}
                                                        className="remove-card-inner"
                                                    >
                                                        <img src={binIcon} alt="remove" className="menu-icon" />
                                                        <span>Remove</span>
                                                    </div>
                                                </>
                                            ) : !profile?.data?.hh_member ? (
                                                <Link
                                                    onClick={() => {
                                                        if (!hasAnySubscription(profile?.data)) {
                                                            toast.dismiss();
                                                            toast.custom((t) => <UpgradeToast t={t} />, { id: "upgrade-toast", duration: 3000 });
                                                        }
                                                    }}
                                                    to={!hasAnySubscription(profile?.data) ? '#' : Routes?.AddHousehold}
                                                    className="remove-card-inner"
                                                >
                                                    <span>+ Add</span>
                                                </Link>
                                            ) : null}
                                        </div>
                                    </div>
                                ) : null}


                            </div>

                        </div>
                        {profile?.data?.hh_member &&
                            <div className='household-info-box'>
                                <div className='info-row'>
                                    <span className='info-label'>Locality</span>
                                    <span className='info-value'>{locality}</span>
                                </div>
                                <div className='info-row'>
                                    <span className='info-label'>Pricing</span>
                                    <span className='info-value'>{pricingType}</span>
                                </div>
                            </div>
                        }
                    </>
                    {/* // ) : (
                    //     <div className='d-flex align-items-center mb-3'>
                    //         <h2 className='form-title m-0'>{HouseHoldName}</h2>
                    //         <Link
                    //             onClick={() => {
                    //                 !profile?.data?.is_premium && toast.error('Please purchase a subscription to access these app features.')
                    //             }}
                    //             to={!profile?.data?.is_premium ? '#' : Routes?.AddHousehold}
                    //             className='small-btn ms-auto'>
                    //             + Add
                    //         </Link>
                    //     </div>
                    // )} */}

                    {/* Tabs */}
                    {profile?.data?.hh_member && (
                        <div className='household-nav-pills'>
                            <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                <li className="nav-item" role="presentation" onClick={() => setMemberType('approved')}>
                                    <button className="nav-link active" id="approved-tab" data-bs-toggle="pill" data-bs-target="#pills-approved" type="button" role="tab" aria-controls="pills-approved" aria-selected="false">Approved</button>
                                </li>
                                <li className="nav-item" role="presentation" onClick={() => setMemberType('pending')}>
                                    <button className="nav-link" id="pending-tab" data-bs-toggle="pill" data-bs-target="#pills-pending" type="button" role="tab" aria-controls="pills-pending" aria-selected="true">Pending</button>
                                </li>
                            </ul>
                        </div>
                    )}

                    {/* Members Header */}
                    {profile?.data?.hh_member && (
                        <div className='members-header'>
                            <h2 className='members-title'>Members</h2>
                            {profile?.data?.role_type === USER_ROLE_TYPES?.GROUP_ADMIN && (
                                <Link to={Routes?.AddInvite} className='add-member-btn'>
                                    <img
                                        src={addIcon}
                                        alt={'photo'}
                                        className="add-icon-img"
                                    /> Add
                                </Link>
                            )}
                        </div>
                    )}

                    {/* Tab Content */}
                    {/* {profile?.data?.hh_member && ( */}
                    <div className="tab-content" id="pills-tabContent">
                        <div className="tab-pane fade show active" id="pills-approved" role="tabpanel" aria-labelledby="approved-tab">
                            <MembersList
                                type='approved'
                                hhMembers={hhMembers}
                                profile={profile}
                                loadingMemb={loadingMemb}
                                handleSendSendCredential={handleSendSendCredential}
                                setInviteMemberForm={setInviteMemberForm}
                                setRemoveId={setRemoveId}
                                onPressEditMember={(member: any) => {
                                    navigate(Routes.AddInvite, { state: { member: member } });
                                }}
                            />
                        </div>

                        <div className="tab-pane" id="pills-pending" role="tabpanel" aria-labelledby="pending-tab">
                            <MembersList
                                type='pending'
                                hhMembers={hhMembers}
                                profile={profile}
                                loadingMemb={loadingMemb}
                                handleSendSendCredential={handleSendSendCredential}
                                setInviteMemberForm={setInviteMemberForm}
                                setRemoveId={setRemoveId}
                            />
                        </div>
                    </div>
                    {/* )} */}



                    {/* Remove Member Modal */}

                    {removeId &&
                        <CustomModal
                            toggleModal={() => { setRemoveId(null) }}
                            onConfirm={handleRemoveMember}
                            title='Are you sure you would like to remove this member?'
                        />
                    }
                    {/* <div className="modal fade inner-modal com-modal" id="removeMemberModal" tabIndex={-1} aria-labelledby="removeMemberModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false"> */}

                    {/* <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-body pt-4 pb-0">
                                    <p className='com-modal-para mb-2 mt-3'>Are you sure you want to <br /> remove this member?</p>
                                </div>
                                <div className='modal-footer border-0 mt-3 justify-content-center'>
                                    <button type='button' className='com-btn com-btn-gray' id='btn-close-modal' data-bs-dismiss="modal" disabled={removeMember?.loading} >Cancel</button>
                                    <Button type='button' className='com-btn' onClick={handleRemoveMember} loading={removeMember?.loading}>Confirm</Button>
                                </div>
                            </div>
                        </div> */}
                    {/* </div> */}

                    {/* Remove Household Modal */}

                    {visibleRemoveHH &&
                        <CustomModal
                            toggleModal={() => { setVisibleRemoveHH(false) }}
                            onConfirm={handleDeleteHouseHold}
                            title='Are you sure you would like to delete this household?'
                        />
                    }

                    {/* <div className="modal fade inner-modal com-modal" id="removeHouseholdModal" tabIndex={-1} aria-labelledby="removeHouseholdModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-body pt-4 pb-0">
                                    <p className='com-modal-para mb-2 mt-3'>Are you sure you would like to <br /> delete this household?</p>
                                </div>
                                <div className='modal-footer border-0 mt-3 justify-content-center'>
                                    <button type='button' className='com-btn com-btn-gray' id='btn-close-household-modal' data-bs-dismiss="modal" disabled={removeMember?.loading} >Cancel</button>
                                    <Button type='button' className='com-btn' onClick={handleDeleteHouseHold} loading={removeMember?.loading}>Confirm</Button>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    {/* Invite Member Modal */}
                    <div className="modal fade inner-modal com-modal" id="memberInviteModal" tabIndex={-1} aria-labelledby="memberInviteModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false" >
                        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" >
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h1 className="modal-title" id="memberInviteModalLabel">Invite Member</h1>
                                </div>
                                <div className="modal-body">
                                    <div className="row gy-3">
                                        <div className="mb-3 com-input-grp">
                                            <label className="form-label">Email<span className='label-star'>*</span></label>
                                            <div className='position-relative icon-input-wrap'>
                                                <input type="email" className="form-control" placeholder='Enter email' onChange={(e) => {
                                                    setInviteMemberForm({ ...inviteMemberForm, email: e?.target?.value })
                                                    if (e?.target?.value) {
                                                        if (ValidationMessage.EMAIL_REGREX.test(e?.target?.value)) {
                                                            setEmailError(null)
                                                        } else {
                                                            setEmailError(ValidationMessage.EMAIL_ADDRESS)
                                                        }
                                                    } else {
                                                        setEmailError(ValidationMessage.Field("your email"))
                                                    }
                                                }} />
                                            </div>
                                            {emailError ? <p className='valid-error'>{emailError}</p> : ''}
                                        </div>

                                        <div className="mb-3 com-input-grp">
                                            <label className="form-label">Mobile Number</label>
                                            <div className='phone-code-select-wrap'>
                                                <CommanPhoneNumber handleMobileNumber={handlePhoneNumber} value={`${inviteMemberForm?.phone_country_code} ${inviteMemberForm?.phone_number}`} />
                                            </div>
                                        </div>
                                        <div className='page-padding-x pb-4 d-flex gap-3'>
                                            <Button className='com-btn flex-grow-1 mt-2' type="button" text="submit" loading={inviteMember?.loading} onClick={handleInvite}>Invite</Button>
                                            <button className='com-btn com-btn-outline flex-grow-1 mt-2 btn-close-modal' data-bs-dismiss="modal" aria-label="Close" disabled={false} type="button" onClick={() => { setEmailError(null); setInviteMemberForm(null) }}>Cancel</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </PageLayout>
    )
}

export default ManageHousehold